import { useMemo } from 'react';

import { SHOW_MAX_LENGTH_WARNING_THRESHOLD } from '../../constants';

interface UseShowMaxLengthWarningProps {
  isFocused: boolean;
  maxLength: number;
  currentLength: number;
}

const useShowMaxLengthWarning = ({
  isFocused,
  maxLength,
  currentLength,
}: UseShowMaxLengthWarningProps) =>
  useMemo(
    () => isFocused && currentLength >= maxLength * SHOW_MAX_LENGTH_WARNING_THRESHOLD,
    [currentLength, maxLength, isFocused],
  );

export default useShowMaxLengthWarning;
